/*
 * Variables are prefixed with 'REACT_APP_' in production so that they are
 * available in the environment variables when the app is built.
 */

export const application = 'dlz-dev';

// e.g. https://www.corpsys.stg.cld.marriott.com
export const baseURL = process.env.REACT_APP_BASE_URL;

// Used for routing to /redirect for SSO Login
export const redirectBaseURL = process.env.REACT_APP_REDIRECT_BASE_URL;

// mh-ld-web e.g. 'https://www.corpsys.stg.cld.m0arriott.com/api/dlz2'
export const apiURL = process.env.REACT_APP_API_URL;

// cmdb-backend e.g. https://www.corpsys.stg.cld.marriott.com/cmdb/api
export const cmdbURL = process.env.REACT_APP_CMDB_API_URL;

export const logoutEnabled = true;

export const gaId = process.env.REACT_APP_DLZ_GA_ID || undefined;
export const disableGA = process.env.REACT_APP_DISABLE_GA === 'true';

export const idleTimeWarnLogout = process.env.REACT_APP_IDLE_TIME_WARN_LOGOUT
  ? Number(process.env.REACT_APP_IDLE_TIME_WARN_LOGOUT)
  : 1000 * 60 * 14;

export const idleTimeLogout = process.env.REACT_APP_IDLE_TIME_LOGOUT
  ? Number(process.env.REACT_APP_IDLE_TIME_LOGOUT)
  : idleTimeWarnLogout + 1000 * 60 * 1;
